import appConfig from '@src/app.config'
import '@babel/polyfill';
import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import i18n from '@src/locales'
import '@components/_globals'

import './plugins/element.js'
import './plugins/can.js'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  i18n,
  router,
  store,
  computed: {
    isTouchDevice() {
      return (
        'ontouchstart' in window ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      )
    },
  },
  created: function() {
    this.initFrame()
  },
  methods: {
    initFrame() {
      if (!this.isTouchDevice) {
        document.querySelector('#frame').style.cssText = `height: ${appConfig.appMaxHeight}; width: ${appConfig.appMaxWidth}px;`
        document.querySelector('body').classList.add('show-frame')
      }
    },
  },
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
